export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "AesWorker.d42e5dbf0ccfe6176aa4.worker.js");
}
